import { jsx } from "panel";
import clamp from "lodash/clamp";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "../button";
import { ButtonSize, ButtonTheme } from "../button/constants";
import { TooltipEl } from "../tooltip";
import { InputLabelEl } from "./label";
import { InputType } from "./types";
function RightIcon({ cmp }) {
  return cmp.attr(`validation-status`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-right-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: { valid: `circle-checkmark`, invalid: `warning` }[cmp.attr(`validation-status`)] }
  })) : cmp.state.value && cmp.attr(`show-clear`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-right-icon.mp-input-clickable-icon",
    on: {
      click: cmp.helpers.handleClearInput
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `circle-clear` }
  })) : cmp.attr(`pre-text`) && cmp.attr(`help-text`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-right-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info-xs` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { text: cmp.attr(`help-text`) }
  })) : null;
}
function NumericControls({ cmp }) {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-numeric-arrow-controls",
    class: { [`input-size-${cmp.attr(`size`)}`]: Boolean(cmp.attr(`size`)) }
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-input-arrow-up",
    attrs: {
      theme: ButtonTheme.Tertiary,
      size: ButtonSize.Tiny,
      icon: `caret-up`
    },
    on: {
      mousedown: (ev) => {
        ev.preventDefault();
        cmp.update({
          value: String(
            clamp(parseInt(cmp.state.value, 10) + 1, parseInt(cmp.attr(`min`), 10), parseInt(cmp.attr(`max`), 10))
          )
        });
        cmp.debouncedChange();
      }
    }
  }), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-input-arrow-down",
    attrs: {
      theme: ButtonTheme.Tertiary,
      size: ButtonSize.Tiny,
      icon: `caret-down`
    },
    on: {
      mousedown: (ev) => {
        ev.preventDefault();
        cmp.update({
          value: String(
            clamp(parseInt(cmp.state.value, 10) - 1, parseInt(cmp.attr(`min`), 10), parseInt(cmp.attr(`max`), 10))
          )
        });
        cmp.debouncedChange();
      }
    }
  }));
}
export function template() {
  const { value } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-container",
    class: { [`theme-${this.attr(`theme`)}`]: true }
  }, this.attr(`label`) ? /* @__PURE__ */ jsx(InputLabelEl, {
    attrs: {
      label: this.attr(`label`),
      "field-id": this.attr(`field-id`),
      necessary: this.attr(`necessary`),
      "help-text": this.attr(`help-text`),
      "extra-info": this.attr(`extra-info`)
    }
  }) : null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-field-container",
    class: {
      [`is-${this.attr(`validation-status`)}`]: Boolean(this.attr(`validation-status`)),
      [`type-${this.attr(`type`)}`]: true,
      [`size-${this.attr(`size`)}`]: true,
      "hide-focus-styling": this.attr(`hide-focus-styling`),
      "is-disabled": this.attr(`disabled`)
    }
  }, (() => {
    var _a, _b;
    const TagName = this.attr(`type`) === `textarea` ? `textarea` : `input`;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-input-left-area"
    }, this.attr(`icon`) && /* @__PURE__ */ jsx("div", {
      sel: ".mp-input-left-icon"
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: this.attr(`icon`) }
    })), this.attr(`pre-text`) && /* @__PURE__ */ jsx("div", {
      sel: ".mp-input-pre-text",
      class: { [`size-${this.attr(`size`)}`]: true },
      on: { click: () => this.focus() }
    }, this.attr(`pre-text`))), /* @__PURE__ */ jsx(TagName, {
      sel: ".mp-input",
      style: {
        "text-align": this.attr(`text-align`)
      },
      attrs: {
        autocomplete: this.attr(`autocomplete`),
        elref: `inputTag`,
        id: this.attr(`field-id`),
        name: this.attr(`field-name`),
        placeholder: this.attr(`placeholder`),
        disabled: this.attr(`disabled`),
        readonly: this.attr(`readonly`),
        size: this.attr(`size`),
        type: TagName === `input` ? this.attr(`type`) : null,
        maxlength: this.attr(`maxlength`),
        minlength: TagName === `input` ? this.attr(`min`) : null,
        min: this.attr(`type`) === `number` ? this.attr(`min`) : null,
        max: this.attr(`type`) === `number` ? this.attr(`max`) : null,
        "not-focusable": this.attr(`not-focusable`)
      },
      props: {
        value
      },
      on: {
        input: this.helpers.handleInput,
        blur: this.helpers.handleBlur,
        focus: this.helpers.handleFocus,
        change: this.helpers.handleChange
      },
      hook: {
        insert: ({ elm }) => {
          this.setElmRef(elm);
        }
      }
    }), /* @__PURE__ */ jsx("div", {
      sel: ".mp-input-right-area"
    }, this.attr(`action-text`) && value ? /* @__PURE__ */ jsx("div", {
      sel: ".mp-input-action-text"
    }, this.attr(`action-text`)) : null, this.attr(`type`) === InputType.Number && this.attr(`show-numeric-input-controls`) && /* @__PURE__ */ jsx(NumericControls, {
      cmp: this
    }), (_b = (_a = this.params).renderRightArea) == null ? void 0 : _b.call(_a), /* @__PURE__ */ jsx(RightIcon, {
      cmp: this
    })));
  })()), this.attr(`validation-status`) === `invalid` && this.attr(`error-message`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-input-error-message"
  }, this.attr(`error-message`)) : null);
}
